import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import type { BudgetPositionFormStore } from "@src/components/modules/budgets/positions/stores/base";
import type { BudgetPositionCreateStore } from "@src/components/modules/budgets/positions/stores/create";
import type { BudgetPositionUpdateStore } from "@src/components/modules/budgets/positions/stores/update";
import { Form, Select, TextField } from "@src/components/ui-kit";
import { observer } from "mobx-react-lite";

type BudgetovacPositionFormProps = {
  store: BudgetPositionFormStore;
};
const BudgetovacPositionForm = observer(function BudgetovacPositionForm({
  store,
}: BudgetovacPositionFormProps) {
  const { form, departmentOptions, isLoadingDepartments } = store;

  return (
    <>
      <TextField
        label={t`Name`}
        placeholder={t`Name`}
        name="name"
        value={form.$.name.value}
        onChange={form.$.name.onChange}
        error={form.$.name.error}
        mb="4"
        autoFocus
      />
      <Select
        label={t`Department`}
        placeholder={t`Select department`}
        name="department_id"
        value={form.$.department_id.value}
        onChange={form.$.department_id.onChange}
        error={form.$.department_id.error}
        options={departmentOptions}
        isClearable
        isLoading={isLoadingDepartments}
      />
    </>
  );
});

type UpdateBudgetovacPositionModalProps = {
  store: BudgetPositionUpdateStore;
};
export const UpdateBudgetovacPositionModal = observer(
  function UpdateBudgetovacPositionModal({
    store,
  }: UpdateBudgetovacPositionModalProps) {
    return (
      <Modal
        closeOnOverlayClick={!store.isSubmitting}
        isOpen={store.disclosure.isOpen}
        onClose={store.disclosure.onClose}
        trapFocus={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Trans>Update position</Trans>
          </ModalHeader>

          <ModalCloseButton isDisabled={store.isSubmitting} />

          <Form
            onSubmit={store.updatePosition}
            id="updateBudgetovacPositionForm"
          >
            <ModalBody>
              <BudgetovacPositionForm store={store} />
            </ModalBody>

            <ModalFooter>
              <Button
                isLoading={store.isSubmitting}
                onClick={store.disclosure.onClose}
                type="reset"
                variant="ghost"
              >
                <Trans>Cancel</Trans>
              </Button>

              <Button
                ml="2"
                form="updateBudgetovacPositionForm"
                isLoading={store.isSubmitting}
                type="submit"
              >
                <Trans>Update</Trans>
              </Button>
            </ModalFooter>
          </Form>
        </ModalContent>
      </Modal>
    );
  },
);

type CreateBudgetovacPositionModalProps = {
  store: BudgetPositionCreateStore;
};
export const CreateBudgetovacPositionModal = observer(
  function CreateBudgetovacPositionModal({
    store,
  }: CreateBudgetovacPositionModalProps) {
    return (
      <Modal
        closeOnOverlayClick={!store.isSubmitting}
        isOpen={store.disclosure.isOpen}
        onClose={store.disclosure.onClose}
        trapFocus={false}
      >
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            <Trans>Create position</Trans>
          </ModalHeader>

          <ModalCloseButton isDisabled={store.isSubmitting} />

          <Form
            onSubmit={store.createPosition}
            id="createBudgetovacPositionForm"
          >
            <ModalBody>
              <BudgetovacPositionForm store={store} />
            </ModalBody>

            <ModalFooter>
              <Button
                isLoading={store.isSubmitting}
                onClick={store.disclosure.onClose}
                type="reset"
                variant="ghost"
              >
                <Trans>Cancel</Trans>
              </Button>

              <Button
                ml="2"
                form="createBudgetovacPositionForm"
                isLoading={store.isSubmitting}
                type="submit"
              >
                <Trans>Create</Trans>
              </Button>
            </ModalFooter>
          </Form>
        </ModalContent>
      </Modal>
    );
  },
);
